interface Message {
  scope: string;
  message: string;
  linkText: string;
  linkUrl: string;
}
const default_messages: Message[] = [
  {
    scope: "sechelp",
    message: "Welcome to maia for Security Policies! Click on the icon below to get started.",
    linkText: "NetApp Security Bot",
    linkUrl: "/activateinfosec",
  },
  {
    scope: "gethelp",
    message: "Welcome to maia for GTM Help! Click on the icon below to get started.",
    linkText: "GTM Help Bot",
    linkUrl: "/activategethelp",
  },
  {
    scope: "cloudonedoc",
    message: "Welcome to maia for Cloudone Docs! Click on the icon below to get started.",
    linkText: "CloudOne Docs",
    linkUrl: "/activatecloudonedoc",
  },
  {
    scope: "competebot",
    message: "Welcome to maia for Competitive Intelligence! Click on the icon below to get started.",
    linkText: "CloudOne Docs",
    linkUrl: "/activatecompetebot",
  },
  {
    scope: "maiawiki",
    message: "Welcome to maia for maia Wiki! Click on the icon below to get started.",
    linkText: "maia Wiki Docs Bot",
    linkUrl: "/activatemaiawiki",
  },
  {
    scope: "noscope",
    message: "Welcome to maia! Click on the icon below to get started.",
    linkText: "maia",
    linkUrl: "/",
  },
  {
    scope: "sharepointlite",
    message: "Welcome to maia for SharePoint! Click on the icon below to get started.",
    linkText: "SharePoint Lite Bot",
    linkUrl: "/activateglobalsharepoint",
  },
  {
    scope: "sharepointliteall",
    message: "Welcome to maia for SharePoint! Click on the icon below to get started.",
    linkText: "NetApp SharePoint Lite Bot",
    linkUrl: "/activateglobalsharepoint",
  }

];

  export default default_messages;
